module.exports = __webpack_public_path__ + "img/notes.70a7495e.svg";